module.exports = __webpack_public_path__ + "static/media/front-end-development.5d4a6e8d.png";